export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'scheduleAvailabilities' as const;

export const RELATIONSHIP_TYPES = {
  USER: 'user',
  SCHEDULE: 'schedule',
  AVAILABILITY_EVENT: 'availability_event',
} as const;

export const AVAILABILITY_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const;
